import React, {Component, useState} from 'react'
import {LayoutHeaderConfig} from 'components/MainLayout'
import {Typography, Radio, List, Avatar, Divider} from "antd";
import "./Subscription.css"
import SubscriptionPlansView from "./SubscriptionPlansView";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {selectPlans} from "../../store/billing/reducer";
import {fetchPlans} from "../../store/billing/actions";
import {selectActiveSubscriptionName} from "../../store/user/reducer";

const {Title, Paragraph} = Typography;


class Subscription extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchPlans();
    }

    subscriptionNotes = [
        'بیمه شهروندی کاربر',
        'هزینه هر دقیقه 1000 تومان',
    ];


    render() {
        const {plans} = this.props;
        console.log(this.props.plans);
        return<React.Fragment>
            <LayoutHeaderConfig closeable={true} pageTitle="جزئیات اشتراک رورو" menuEnabled={false} extra={[]}/>
            <SubscriptionPlansView plans={plans} subscriptionNotes={this.subscriptionNotes}
                                   activeSubscriptionName={this.props.activeSubscriptionName}
            />
        </React.Fragment>
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchPlans,
    },
    dispatch);

const mapStateToProps = state => ({
    plans: selectPlans(state),
    activeSubscriptionName: selectActiveSubscriptionName(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Subscription))
